module.exports = function getResource(label) {
    let resources = {
        seeMore: 'Voir plus',
        showMore: 'Afficher plus',
        signInButton: 'Ouvrir une session pour découvrir',
        viewPersonalizedRecommendations: 'Consulter les recommandations personnalisées',
        createAnAccount: 'Créer un compte',
        notABeautyInsider: 'Vous n’êtes pas membre Beauty Insider?',
        blurredRecommendedTitle: 'Recommandé pour vous'
    };
    return resources[label];
};
